module.exports = __webpack_public_path__ + "static/sanika_recruitment-7acd94cf414d33e15f81aff48ab542dc.jpg";